// src/components/StudentPendingApproval.jsx
// Shown instead of the student dashboard while the student's active tutor
// hasn't confirmed them yet (approvalPending - see "Tutor approval" in
// functions/index.js). The same thing is enforced server-side, so this is
// the friendly face of it, not the only guard. A student who also has an
// already-approved tutor can switch to them from here while they wait.

import React from 'react';
import { Lock, LogOut } from 'lucide-react';
import { logout } from '../firebase/auth';
import StudentTutorPanel from './StudentTutorPanel';

const StudentPendingApproval = ({ user, onLogout }) => {
  const handleLogout = async () => {
    try {
      await logout();
      onLogout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f7fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div style={{ maxWidth: '520px', width: '100%', background: 'white', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', padding: '32px', textAlign: 'center' }}>
        <Lock size={36} color="#c33329" style={{ marginBottom: '12px' }} />
        <h1 style={{ fontSize: '20px', margin: '0 0 12px 0', color: '#2d3748' }}>Waiting for your tutor to confirm you</h1>
        <p style={{ fontSize: '15px', color: '#4a5568', lineHeight: 1.6, margin: '0 0 8px 0' }}>
          To access the site you need to be confirmed by your tutor. Please contact them so they know you are waiting for this.
        </p>
        {user.cohortName && (
          <p style={{ fontSize: '13px', color: '#718096', margin: '0 0 20px 0' }}>
            Cohort: {user.cohortName}
          </p>
        )}
        <p style={{ fontSize: '13px', color: '#718096', margin: '0 0 20px 0' }}>
          Once they have, log out and back in (or refresh this page) to get started.
        </p>
        <div style={{ marginBottom: '24px' }}>
          <StudentTutorPanel user={user} compact />
        </div>
        <button
          type="button"
          onClick={handleLogout}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '14px', cursor: 'pointer' }}
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default StudentPendingApproval;
